import { api } from "../../utils/api";


export async function postSchedulesExcel(data) {
    try {
        const response = await api.post(`schedule/excel`, data);
        return response.data;
    }  catch (error) {
    
        const errorMessage = error.response?.data?.error || "Erro inesperado.";
    
    
        throw new Error(errorMessage);
      }
}
